import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

// «Eliminar» un chat: no se borra, pasa a «Chats eliminados». Si es el principal (y quedan otros chats), se elige cuál lo será.
export function DeleteConversationDialog({ conversation, conversations, busy = false, error = "", onConfirm, onCancel }) {
  const others = (conversations || []).filter((c) => c.kind !== "tema" && c.id !== conversation?.id);
  const topics = (conversations || []).filter((c) => c.parent_conversation_id === conversation?.id);
  const needsPick = !!conversation?.is_main && others.length > 0;
  const [newMain, setNewMain] = useState("");
  useEffect(() => setNewMain(others[0]?.id || ""), [conversation?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={!!conversation} onOpenChange={(open) => { if (!open && !busy) onCancel(); }}>
      <DialogContent data-testid="delete-conversation-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>¿Eliminar «{conversation?.title}»?</DialogTitle>
          <DialogDescription>
            No se borra: pasa a «Chats eliminados», donde puedes verlo, restaurarlo o pedirle a la IA que lo consulte.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          {topics.length > 0 && (
            <p data-testid="delete-topics-warning" className="text-amber-500">
              Tiene {topics.length} tema{topics.length === 1 ? "" : "s"}: {topics.length === 1 ? "se va" : "se van"} con él.
            </p>
          )}
          {needsPick && (
            <fieldset data-testid="new-main-picker" className="space-y-1.5">
              <legend className="font-medium mb-1">Este es tu chat principal. ¿Cuál será el principal ahora?</legend>
              {others.map((c) => (
                <label key={c.id} className="flex items-center gap-2 cursor-pointer">
                  <input type="radio" name="new-main" data-testid={`new-main-option-${c.id}`} value={c.id} checked={newMain === c.id} onChange={() => setNewMain(c.id)} />
                  <span className="truncate">{c.title}</span>
                </label>
              ))}
            </fieldset>
          )}
          {conversation?.is_main && !needsPick && (
            <p data-testid="delete-only-chat" className="text-muted-foreground">Es tu único chat: el siguiente que crees será el principal.</p>
          )}
          {error && <p data-testid="delete-conversation-error" className="text-amber-500">{error}</p>}
        </div>
        <DialogFooter>
          <Button data-testid="delete-conversation-cancel" variant="outline" size="sm" disabled={busy} onClick={onCancel}>Cancelar</Button>
          <Button data-testid="delete-conversation-confirm" size="sm" disabled={busy || (needsPick && !newMain)} onClick={() => onConfirm({ newMainId: needsPick ? newMain : null })}>
            Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

// Eliminar DEFINITIVAMENTE un chat que ya estaba en «Chats eliminados»: lo único que borra de verdad.
export function PurgeConversationDialog({ conversation, busy = false, error = "", onConfirm, onCancel }) {
  return (
    <Dialog open={!!conversation} onOpenChange={(open) => { if (!open && !busy) onCancel(); }}>
      <DialogContent data-testid="purge-conversation-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>¿Eliminar definitivamente «{conversation?.title}»?</DialogTitle>
          <DialogDescription>
            Se borran sus mensajes, adjuntos y plan (y sus temas, si tiene). <strong>No se puede deshacer.</strong>
          </DialogDescription>
        </DialogHeader>
        {error && <p data-testid="purge-conversation-error" className="text-sm text-amber-500">{error}</p>}
        <DialogFooter>
          <Button data-testid="purge-conversation-cancel" variant="outline" size="sm" disabled={busy} onClick={onCancel}>Cancelar</Button>
          <Button data-testid="purge-conversation-confirm" size="sm" variant="outline" className="text-red-500" disabled={busy} onClick={onConfirm}>Sí, eliminar definitivamente</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
